import type { Partner, TransformedPartner } from '@/types/partner';
import type { ExpertData } from '@/types/expert';
import type { TransformedExpert } from '@/components/Modal/ExpertDetailsModal';

export const transformPartnerData = (partner: Partner): TransformedPartner => {
  if (!partner) {
    return {} as TransformedPartner;
  }

  return {
    id: partner.id,
    name: partner.attributes.name,
    description: partner.attributes.description,
    logo: partner.attributes.logo?.data?.attributes?.url || '',
    title: partner.attributes.title,
    imageUrl: partner.attributes.cover.data?.attributes.url || '',
    features: partner.attributes.features.map((feature) => feature.point),
    external_id: partner.attributes.external_id,
    short_description: partner.attributes.short_description,
    languages: partner.attributes.languages.data.map((lang) => lang.attributes.name),
  };
};

export const transformExpertData = (expert: ExpertData): TransformedExpert => {
  if (!expert) {
    return {} as TransformedExpert;
  }

  return {
    imageUrl: expert.attributes.picture.data?.attributes.url || '',
    name: expert.attributes.name,
    title: expert.attributes.type,
    description: expert.attributes.description,
    tags: expert.attributes.categories?.data.map((cat) => cat.attributes.Name),
    experience: expert.attributes.languages?.data?.length
      ? expert.attributes.languages.data?.map((lang) => lang.attributes.name)?.join(', ')
      : 'No languages available',
    expertId: expert.attributes.external_id,
    id: expert.id.toString(),
    external_id: expert.attributes.external_id,
  };
};
